/**
 * Function that toggles the list contents menu.
 */
export default function indicatorList () {
  const listSelector = '[data-type="organism/indicator/list"]'
  const lists = document.querySelectorAll( listSelector )
  const body = document.querySelector( 'BODY' )
  const bodyIndicator = body.dataset.categoryColor
  const indicatorHash = window.location.hash

  if ( lists.length < 1 ) {
    return
  }

  for ( let l = 0; l < lists.length; l++ ) {
    configToggle( lists[l])
  }

  openCategoryList( lists, bodyIndicator )
  if ( '#goto-indicator-list' === indicatorHash ) {
    scrollToCategoryList( lists )
  }

  /**
   * Config lists.
   * @param {Object} list Wrapper element object holding the list.
   */
  function configToggle( list ) {
    const contract = list.querySelector( '[data-contract]' )
    const wrapper = list.querySelector( '[data-list]' )
    contract.addEventListener( 'click', () => toggle( wrapper, contract ) )
  }

  /**
   * Perform the toggle.
   * @param {Object} wrapper  Wrapper element object holding then list.
   * @param {Object} contract Button element to close/open list.
   */
  function toggle ( wrapper, contract ) {
    if ( wrapper.dataset.list === 'open' ) {
      wrapper.classList.add( 'collapsed' )
      wrapper.dataset.list = 'closed'
      contract.classList.add( 'rotate-180' )
    } else {
      wrapper.classList.remove( 'collapsed' )
      wrapper.dataset.list = 'open'
      contract.classList.remove( 'rotate-180' )
    }

  }

  /**
   * Open list(s) of current indicator category.
   * @param {array}  lists Array holding the page lists.
   * @param {string} categoryColor Page category color.
   */
  function openCategoryList( lists, categoryColor ) {
    let list = null
    const onlyCat = 'green' !== categoryColor && 'white' !== categoryColor 

    if ( onlyCat ) {
      for ( let l = 0; l < lists.length; l++ ) {
        list = lists.item( l )
        if ( onlyCat && list.dataset.categoryColor === categoryColor ) {
          const contract = list.querySelector( '[data-contract]' )
          const wrapper = list.querySelector( '[data-list]' )
          toggle( wrapper, contract )
          break
        }
      }
      return
    }

    for ( let l = 0; l < lists.length; l++ ) {
      list = lists.item( l )
      const contract = list.querySelector( '[data-contract]' )
      const wrapper = list.querySelector( '[data-list]' )
      toggle( wrapper, contract )
    }

  }

  /**
   * Open list(s) of current indicator category.
   * @param {array}  lists Array holding the page lists.
   */
  function scrollToCategoryList( lists ) {
    const firtList = lists.item( 0 )
    firtList.scrollIntoView()
  }
}
  